import { useLocation } from "react-router-dom";
import { NotificationItem } from "../NotificationItem";
import { useStyles } from "./ReturnNotification.style";
import { Dialog } from "../../core/Dialog/Dialog";
import { Typography } from "../../core/Typography/Typography";
import { TypographyVariant } from "../../../constants/typography";
import Button from "../../core/Button/Button";
import { FC, HTMLAttributes, useEffect } from "react";
import { useAppDispatch, useAppSelector } from "../../hooks";
import { addPopupQueue, removePopupQueue } from "../../../store/slices/popup";
import { PopupType } from "../../../constants/popup";
import { UserNotification } from "@onmo/graphql/graphql";
import { loginRewardsGQL } from "../../../graphql";
import { GamingLocation } from "../../../models/gamingLocation";
import { useQuery } from "@apollo/client";
import { disablePopupNotification } from "../../../store/slices/inAppNotification";

interface IReturnNotificationProps {
  userNotifications: UserNotification[];
}

export const ReturnNotification: FC<
  IReturnNotificationProps & HTMLAttributes<HTMLDivElement>
> = ({ userNotifications }) => {
  const classes = useStyles();
  const dispatch = useAppDispatch();
  const location = useLocation();
  const { data: loginRewardsData } = useQuery(loginRewardsGQL, {
    fetchPolicy: "cache-only",
  });

  const { currentPopupId } = useAppSelector((state) => state.popup);
  const isOpen = currentPopupId === PopupType.ReturnNotification;

  const closeNotification = () => {
    localStorage.setItem(
      "recentNotificationTime",
      userNotifications?.[0]?.createdAt || "",
    );
    dispatch(removePopupQueue({ type: PopupType.ReturnNotification }));
    dispatch(disablePopupNotification());
  };

  useEffect(() => {
    if (userNotifications.length) {
      dispatch(addPopupQueue({ type: PopupType.ReturnNotification }));
      localStorage.setItem("has_unread", "1");
    } else {
      localStorage.removeItem("has_unread");
    }
  }, [!!userNotifications.length, dispatch]);

  return (
    <Dialog
      open={
        isOpen &&
        (!!loginRewardsData ||
          !GamingLocation.isActiveHomePage(location.pathname))
      }
    >
      <Typography variant={TypographyVariant.HeadingH5Bold}>
        Notifications
      </Typography>
      <div className={classes.root}>
        {userNotifications.map((item: UserNotification, idx: number) => (
          <NotificationItem
            notification={item}
            key={item.id + idx}
            className={classes.noti}
            onClose={() => closeNotification()}
          />
        ))}
      </div>
      <Button fullWidth className={classes.btn} onClick={closeNotification}>
        Close
      </Button>
    </Dialog>
  );
};
